import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ContractorPortalStep } from 'enums/ContractorPortalStep';
import { SignInStep } from 'prequalificationV2/pages/SignInProcess/signInStep.enums';
import { PreQualificationStep } from 'enums/PreQualificationStep';
import { DashboardStep } from 'enums/DashboardStep';

interface StagesState {
  currentPreQualificationStep: PreQualificationStep | null;
  currentSignInStep: SignInStep | null;
  currentDashboardStep: DashboardStep | null;
  currentContractorPortalStep: ContractorPortalStep | null;
  nextPreQualificationStep: PreQualificationStep | null;
}

const initialState: StagesState = {
  currentPreQualificationStep: null,
  currentSignInStep: null,
  currentDashboardStep: null,
  currentContractorPortalStep: null,
  nextPreQualificationStep: null,
};

const stages = createSlice({
  name: 'stages',
  initialState: initialState,
  reducers: {
    setPreQualificationStep: function (state, { payload }: PayloadAction<PreQualificationStep | null>) {
      state.currentPreQualificationStep = payload;
    },
    setDashboardStep: function (state, { payload }: PayloadAction<DashboardStep | null>) {
      state.currentDashboardStep = payload;
    },
    setSignInStep: function (state, { payload }: PayloadAction<SignInStep | null>) {
      state.currentSignInStep = payload;
    },
    setContractorPortalStep: function (state, { payload }: PayloadAction<ContractorPortalStep | null>) {
      state.currentContractorPortalStep = payload;
    },
    setNextPreQualificationStep: function (state, { payload }: PayloadAction<PreQualificationStep | null>) {
      state.nextPreQualificationStep = payload;
    },
    resetAllSteps: function (state) {
      state.currentContractorPortalStep = null;
      state.currentSignInStep = null;
      state.currentDashboardStep = null;
      state.currentPreQualificationStep = null;
      state.nextPreQualificationStep = null;
    },
  },
});

export const {
  setPreQualificationStep,
  setDashboardStep,
  setSignInStep,
  setContractorPortalStep,
  setNextPreQualificationStep,
  resetAllSteps,
} = stages.actions;

export default stages.reducer;
